export const ensureUtcIso = (value) => {
  const text = String(value || '').trim();
  if (!text) return null;
  return /([zZ]|[+-]\d{2}:?\d{2})$/.test(text) ? text : `${text}Z`;
};

export const formatIstDateTime = (value) => {
  const iso = ensureUtcIso(value);
  if (!iso) return '-';

  const parsed = new Date(iso);
  if (Number.isNaN(parsed.getTime())) return '-';

  return new Intl.DateTimeFormat('en-LK', {
    timeZone: 'Asia/Colombo',
    dateStyle: 'medium',
    timeStyle: 'short',
  }).format(parsed);
};

export const formatIstDate = (value) => {
  const iso = ensureUtcIso(value);
  if (!iso) return '-';

  const parsed = new Date(iso);
  if (Number.isNaN(parsed.getTime())) return '-';

  return new Intl.DateTimeFormat('en-LK', {
    timeZone: 'Asia/Colombo',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  }).format(parsed);
};
